function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("metadata", null);
var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  transform: "matrix(.39652 0 0 .40021 .60241 .9821)",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2.5103
}, React.createElement("path", {
  d: "m2.5 9.833c0-0.736 0.597-1.333 1.333-1.333h42.334c0.736 0 1.333 0.597 1.333 1.333v5.334c0 0.736-0.597 1.333-1.333 1.333h-42.334c-0.736 0-1.333-0.597-1.333-1.333z"
}), React.createElement("path", {
  d: "m2.5 29.833c0-0.736 0.597-1.333 1.333-1.333h42.334c0.736 0 1.333 0.597 1.333 1.333v5.334c0 0.736-0.597 1.333-1.333 1.333h-42.334c-0.736 0-1.333-0.597-1.333-1.333z"
}), React.createElement("path", {
  d: "m2.5 49.833c0-0.736 0.597-1.333 1.333-1.333h42.334c0.736 0 1.333 0.597 1.333 1.333v5.334c0 0.736-0.597 1.333-1.333 1.333h-42.334c-0.736 0-1.333-0.597-1.333-1.333z"
}), React.createElement("path", {
  d: "m2.5 69.833c0-0.736 0.597-1.333 1.333-1.333h42.334c0.736 0 1.333 0.597 1.333 1.333v5.334c0 0.736-0.597 1.333-1.333 1.333h-42.334c-0.736 0-1.333-0.597-1.333-1.333z"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "icon-primary",
  transform: "matrix(.3851 0 0 .38475 3.2297 2.2728)",
  fill: "#ecaec6",
  strokeMiterlimit: 8,
  strokeWidth: 2.5979
}, React.createElement("rect", {
  x: 60.5,
  y: 63.5,
  width: 21,
  height: 20
}), React.createElement("rect", {
  x: 81.5,
  y: 21.5,
  width: 21,
  height: 21
}), React.createElement("rect", {
  x: 102.5,
  y: 42.5,
  width: 20,
  height: 21
}), React.createElement("rect", {
  x: 122.5,
  y: 42.5,
  width: 21,
  height: 21
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "icon-secondary",
  transform: "matrix(.3871 0 0 .38475 3.1083 1.9636)",
  fill: "#adb9ca",
  strokeMiterlimit: 8,
  strokeWidth: 2.5911
}, React.createElement("rect", {
  x: 60.5,
  y: 1.5,
  width: 21,
  height: 20
}), React.createElement("rect", {
  x: 81.5,
  y: 42.5,
  width: 21,
  height: 21
}), React.createElement("rect", {
  x: 102.5,
  y: 1.5,
  width: 20,
  height: 20
}), React.createElement("rect", {
  x: 122.5,
  y: 21.5,
  width: 21,
  height: 21
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#002060"
}, React.createElement("rect", {
  className: "icon-tertiary",
  x: 26.533,
  y: 2.4574,
  width: 32.041,
  height: 32.088,
  strokeMiterlimit: 8
}), React.createElement("g", null, React.createElement("path", {
  className: "icon-tertiary",
  d: "m26.625 10.5h32",
  strokeWidth: "1px"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m26.604 26.542h32.083",
  strokeWidth: "1px"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m26.354 18.542h32.167",
  strokeWidth: "1px"
}), React.createElement("g", {
  strokeWidth: "1px"
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m34.583 2.3542v32.333"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m42.542 2.2917v32.333"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m50.542 2.25v32.333"
}))));
var SvgMenuHeatmap = function SvgMenuHeatmap(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    overflow: "hidden",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuHeatmap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-heatmap.097724cc.svg";
export { ForwardRef as ReactComponent };